var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"law-guide-container"},[_c('mars-view',{staticClass:"lvlin-home",nativeOn:{"click":function($event){return _vm.goLvlinHome.apply(null, arguments)}}},[_c('mars-view',{staticClass:"desc"},[_vm._v("律临首页")]),_c('mars-view',{staticClass:"icon"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }